const initialState = false;

export const SET_LOADING_STATE = "SET_LOADING_STATE";
export const loadingAction = (data) => ({
  type: SET_LOADING_STATE,
  payload: data,
});

export default function loadingReducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case SET_LOADING_STATE:
      return {
        ...state,
      };
    default:
      return state;
  }
}
